module.exports = __webpack_public_path__ + "img/arrow-right.77ec8db2.svg";